import TabList from '../Tabs/TabList';
import { Tabs, Tab, TabPanel } from '@/components/Tabs';
import { GET_TAB_OPTIONS } from './AvatarOptions.settings';
import { useRef, useState, useCallback, useMemo } from 'react';
import RandomIcon from '@/assets/images/icons/random.svg?component';
import type { IAvatarOptionsPops, ITabOption, ITypeOfOptions } from './types';

const AvatarOptions: React.FC<IAvatarOptionsPops> = ({
  toggleButtons,
  scrollRight,
  onTabClick,
  setOptions,
  setIsFocus,
  activeTab,
  options
}) => {
  const canClick = useRef(!!options.name);
  const [visibleColorPanel, setVisibleColorPanel] = useState(false);

  const HandleChangeOptions = useCallback(
    (key: ITypeOfOptions, value: unknown) =>
      setOptions((state) => ({
        ...state,
        [key]: value
      })),
    [setOptions]
  );

  const toggleColorPanel = (visible: boolean) => {
    setVisibleColorPanel(visible);
    toggleButtons?.(!visible);
  };

  const { tabListItems, tabPanelsItem } = useMemo(() => {
    const tabPanelsItem: JSX.Element[] = [];
    canClick.current = !!options.name;

    const tabListItems: JSX.Element[] = [
      <Tab key="shuffle" value="-1" label="Verras me" icon={<RandomIcon />} />
    ];

    const items: ITabOption[] = GET_TAB_OPTIONS({
      setOption: HandleChangeOptions,
      setFocus: setIsFocus,
      toggleColorPanel,
      options
    });

    items.forEach(({ value, label, icon, component }, i) => {
      tabListItems.push(
        <Tab key={`tab-${i}`} value={value} label={label} icon={icon} />
      );

      tabPanelsItem.push(
        <TabPanel key={`tab-panel-${i}`} value={value}>
          {component}
        </TabPanel>
      );
    });

    return { tabPanelsItem, tabListItems };
  }, [HandleChangeOptions, options]);

  return (
    <Tabs
      colorPanel={visibleColorPanel}
      onSetCurrentTab={onTabClick}
      canClick={canClick.current}
      activeTab={activeTab}
    >
      <TabList colorPanel={visibleColorPanel} scrollRight={scrollRight}>
        {tabListItems}
      </TabList>

      {...tabPanelsItem}
    </Tabs>
  );
};

export default AvatarOptions;
